import { render, staticRenderFns } from "./SharePage.vue?vue&type=template&id=47b5d964&"
import script from "./SharePage.vue?vue&type=script&lang=js&"
export * from "./SharePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports